export enum TipoPrestador {
	Comerciante = '1',
	Guia = '2'
}

